<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1329_6327)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.3564 9.33325C16.3564 6.94014 14.4163 5 12.0232 5C9.63008 5 7.68994 6.94014 7.68994 9.33325C7.68994 11.7264 9.63008 13.6665 12.0232 13.6665C14.4163 13.6665 16.3564 11.7264 16.3564 9.33325Z"
        fill="currentColor"
      />
      <path
        d="M7.3358 11.8014C7.37971 11.8843 7.36093 11.988 7.28553 12.0438C6.72538 12.4583 6.03235 12.7036 5.28212 12.7036C3.42084 12.7036 1.91172 11.1947 1.91172 9.33317C1.91172 7.47161 3.42056 5.96277 5.28212 5.96277C6.03235 5.96277 6.72538 6.20803 7.28553 6.62258C7.36093 6.67833 7.37942 6.78204 7.3358 6.86495C6.94696 7.60189 6.72683 8.44197 6.72683 9.33317C6.72683 10.2244 6.94696 11.0645 7.3358 11.8014Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.7019 15.303C15.5151 14.7879 13.958 14.6296 12.0231 14.6296C10.0882 14.6296 8.52819 14.7882 7.34117 15.3045C6.04812 15.8666 5.26207 16.8246 4.85012 18.1768C4.65715 18.8107 5.13323 19.4445 5.78929 19.4445H18.2552C18.9121 19.4445 19.3891 18.8098 19.1955 18.1748C18.783 16.8223 17.9958 15.8649 16.7019 15.3033V15.303Z"
        fill="currentColor"
      />
      <path
        d="M6.90178 13.7017C7.30044 13.7266 7.32384 14.2622 6.95753 14.4213C5.95366 14.8578 5.19794 15.5003 4.656 16.3204C4.21112 16.9935 3.5204 17.5184 2.71383 17.5184H0.99931C0.318412 17.5184 -0.178469 16.8419 0.0610151 16.1806C0.0748816 16.1425 0.0890369 16.1049 0.104059 16.0674C0.433675 15.2348 0.99902 14.6218 1.83563 14.2312C2.62139 13.8644 3.60475 13.713 4.76346 13.6673L4.78253 13.6665H4.8016C5.48423 13.6665 6.1969 13.6578 6.90207 13.7014L6.90178 13.7017Z"
        fill="currentColor"
      />
      <path
        d="M17.273 9.33317C17.273 8.44197 17.0529 7.60189 16.6641 6.86495C16.6201 6.78204 16.6389 6.67833 16.7143 6.62258C17.2745 6.20803 17.9675 5.96277 18.7177 5.96277C20.579 5.96277 22.0881 7.47161 22.0881 9.33317C22.0881 11.1947 20.5793 12.7036 18.7177 12.7036C17.9675 12.7036 17.2745 12.4583 16.7143 12.0438C16.6389 11.988 16.6204 11.8843 16.6641 11.8014C17.0529 11.0645 17.273 10.2244 17.273 9.33317Z"
        fill="currentColor"
      />
      <path
        d="M19.1984 13.6665H19.2174L19.2365 13.6673C20.3952 13.713 21.3789 13.8644 22.1644 14.2312C23.0012 14.6218 23.5663 15.2348 23.8959 16.0674C23.9107 16.1049 23.9251 16.1425 23.939 16.1806C24.1784 16.8416 23.6816 17.5185 23.0007 17.5185H21.2861C20.4796 17.5185 19.7889 16.9936 19.344 16.3205C18.802 15.5003 18.046 14.8578 17.0424 14.4213C16.6761 14.2622 16.6995 13.7266 17.0982 13.7017C17.8031 13.6578 18.516 13.6668 19.1987 13.6668L19.1984 13.6665Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1329_6327">
        <rect width="24" height="24" fill="currentColor" transform="matrix(-1 0 0 1 24 0)" />
      </clipPath>
    </defs>
  </svg>
</template>
